import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import App from 'app/app';
import 'react-modern-drawer/dist/index.css';
import './app/styles/index.scss';

const domNode = document.getElementById('app') as HTMLElement;
const root = createRoot(domNode);
root.render(<App />);
